import { FC, ReactElement, useRef } from 'react';

import { useToggle } from 'react-use';

import { IconButton } from '../../compositions';
import trans, { Locale } from '../../helpers/trans';
import useHandleClickOutside from '../../hooks/useHandleClickOutside';
import { LocaleSwitcherList } from './subcomponents';

import './LocaleSwitcher.scss';

export interface LocaleSwitcherProps {
    locale: Locale;
    onLocaleChange: (preferredLocale: Locale) => void;
    className?: string;
}

const LocaleSwitcher: FC<LocaleSwitcherProps> = ({
    locale,
    onLocaleChange,
    className = '',
}): ReactElement => {
    const [switcherIsOpen, toggleSwitcherIsOpen] = useToggle(false);

    const localeSwitcherRef = useRef<HTMLDivElement>(null);
    useHandleClickOutside(localeSwitcherRef, () => toggleSwitcherIsOpen(false));

    const handleLocaleChange = (preferredLocale: Locale): void => {
        toggleSwitcherIsOpen(false);
        onLocaleChange(preferredLocale);
    };

    return (
        <div ref={localeSwitcherRef} className={`locale-switcher ${className}`}>
            <IconButton
                icon="locale"
                text={trans(`containers.localeSwitcher.${switcherIsOpen ? 'closeNav' : 'openNav'}`)}
                hideLabel
                onClick={toggleSwitcherIsOpen}
                className="locale-switcher__toggle-button"
                iconClassName="locale-switcher__toggle-icon"
            />

            <LocaleSwitcherList
                isActive={switcherIsOpen}
                activeLocale={locale}
                onLocaleSelect={handleLocaleChange}
                className="locale-switcher__nav"
            />
        </div>
    );
};

export default LocaleSwitcher;
